import React, { useEffect, useRef, useState } from "react";
import Card from "components/card";
import { useSelector } from "react-redux";
import { currentUser } from "services/users/authSlice";
import { ESService } from "services/esService";
import ApiList from "services/apiList";
import Accordion from "./components/Accordion";
import Loader from "components/loader";
const TeacherSchedule = () => {
  var user = useSelector(currentUser);
  const [loading, setLoading] = useState(true);
  const [day, setDay] = useState({
    monday: [],
    tuesday: [],
    wednesday: [],
    thursday: [],
    friday: [],
  });
  const mount = useRef(true);

  useEffect(() => {
    if (mount.current) {
      mount.current = false;
      try {
        const token = user.token;
        const es = new ESService(token);
        es.get(ApiList.teacherScheduleUrl, "userId=" + user.id).then((json) => {
          setLoading(false);
          if (json["status"]) {
            var day1 = [];
            var day2 = [];
            var day3 = [];
            var day4 = [];
            var day5 = [];
            for (let i = 0; i < json["data"].length; i++) {
              var d = json["data"][i];
              if (d.day === 1) {
                day1.push(d);
              } else if (d.day === 2) {
                day2.push(d);
              } else if (d.day === 3) {
                day3.push(d);
              } else if (d.day === 4) {
                day4.push(d);
              } else {
                day5.push(d);
              }
            }
            setDay({
              monday: day1,
              tuesday: day2,
              wednesday: day3,
              thursday: day4,
              friday: day5,
            });
          }
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  }, [day, user]);

  return (
    <Card extra={"w-full pb-10 p-4 h-full"}>
      {loading ? (
        <Loader />
      ) : (
        <div>
          <Accordion data={day["monday"]} text="Даваа" />
          <Accordion data={day["tuesday"]} text="Мягмар" />
          <Accordion data={day["wednesday"]} text="Лхагва" />
          <Accordion data={day["thursday"]} text="Пүрэв" />
          <Accordion data={day["friday"]} text="Баасан" />
        </div>
      )}
    </Card>
  );
};

export default TeacherSchedule;
